import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import TourManagementOptionsSidebar from "../components/tour/TourManagementSidebarOptionsSidebar";
import InfoCardLightening from "../components/tour/InfoCardLightening";
import CustomRadio from "../components/common/CustomRadio";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setOptionsData, setPackageData } from "../reducer/tourReducer";
import { FormControl, MenuItem, Select } from "@mui/material";
import { useOptions } from "../hooks/useOptions";
import { resetOptionEdit } from "../reducer/tourEditReducer";

function TourManagementPackageConnectivityPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { packageData, optionsData, packageId } = useSelector(
    (state: RootState) => state.tour
  );
  const {
    tourEdit,
    optionId,
    id: editPackageId,
  } = useSelector((state: RootState) => state.edit);
  const { createPreOptions } = useOptions();
  const progressref = useRef(13);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState("");
  const { PrepackageDataId } = useSelector((state: RootState) => state.tour);

  useEffect(() => {
    if (location.state && location.state.optionData) {
      dispatch(setOptionsData(location.state.optionData));
    }
  }, [location.state, dispatch]);

  const [editedReservation, setEditedReservation] = useState(
    optionsData?.reservations || false
  );
  const [editedReservationSystem, setEditedReservationSystem] = useState(
    optionsData?.reservationSystem || ""
  );
  const [editedExternalProductId, setEditedExternalProductId] = useState(
    optionsData?.externalProductId || ""
  );

  useOnLoadPage({ tabActive: "create" });

  const onSave = async () => {
    console.log(packageData);

    const updatedPackageData = {
      ...optionsData,
      id: optionsData._id,
      progress: Number(progressref.current),
      reservations: optionsData?.reservations,
      reservationSystem: optionsData?.reservationSystem,
      externalProductId: optionsData?.externalProductId,
    };

    const updatedPackageData2 = {
      ...optionsData,
      ...updatedPackageData,
    };

    setLoading(true);
    try {
      if (tourEdit) {
        dispatch(resetOptionEdit());
        dispatch(setOptionsData(updatedPackageData2));
        const pkgId = packageData._id;
        navigate(`/manage/product/${pkgId}/${optionId}`, {
          state: {
            fromEdit: true,
            option: updatedPackageData2,
            packageId: pkgId,
          },
        });
        return;
      } else {
        await createPreOptions(updatedPackageData);
      }
      navigate(Paths.tourManagementPackageOptions);
    } catch (error) {
      console.error("Error saving package:", error);
      setError("Failed to save the package. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onContinue = () => {
    navigate(Paths.tourManagementPackageOptionsAvailability);
  };

  const reservationSystem = [
    "Bokun",
    "Rezdy",
    "Travelotopos",
    "Ventrata",
    "AnyRoad",
    "Avion",
  ];

  console.log("packagedata", packageData);

  useEffect(() => {
    if (typeof optionsData?.reservations === "undefined") {
      dispatch(setOptionsData({ ...optionsData, reservations: false }));
    }
  }, []);

  const handleBack = () => {
    navigate(Paths.tourManagementPackageOptionsMeeting);
  };

  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementOptionsSidebar selected={3} />
        <div className={Classname.detail}>
          <InfoCardLightening
            description={
              <div className="flex flex-col gap-1">
                <li>If you use a reservation system, please click here</li>
              </div>
            }
          />
          <div className={Classname.title}>Connectivity Settings</div>
          <div className={Classname.description}>
            Intraverse supports API integrations with industry-leading channel
            managers, ticketing and reservation systems, allowing suppliers to
            manage all of their bookings and availability in one place. Learn
            more.
          </div>

          <div className={Classname.title}>
            Do you use an online reservation system?
          </div>
          <CustomRadio
            label="No, I don’t"
            value={false}
            selected={editedReservation}
            onSelect={() => {
              setEditedReservation(false);
              dispatch(
                setOptionsData({
                  ...optionsData,
                  reservations: false,
                })
              );
            }}
          />

          <CustomRadio
            label="Yes, I use a reservation system"
            value={true}
            selected={editedReservation}
            onSelect={() => {
              setEditedReservation(true);
              dispatch(
                setOptionsData({
                  ...optionsData,
                  reservations: true,
                })
              );
            }}
          />

          <div>
            {optionsData?.reservations && (
              <>
                <div className={Classname.title2}>
                  Select Your Reservation System
                </div>
                <div className="flex flex-1">
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={editedReservationSystem}
                      className="mt-2"
                      onChange={(e) => {
                        setEditedReservationSystem(e.target.value);
                        dispatch(
                          setOptionsData({
                            ...optionsData,
                            reservationSystem: e.target.value,
                          })
                        );
                      }}
                    >
                      {reservationSystem.map((reservation, index) => (
                        <MenuItem value={reservation} key={index}>
                          {reservation}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div>
                  <div className="mt-4 font-bold ">External product ID</div>
                  <input
                    className={Classname.input}
                    placeholder=""
                    value={editedExternalProductId}
                    onChange={(e) => {
                      setEditedExternalProductId(e.target.value);
                      dispatch(
                        setOptionsData({
                          ...optionsData,
                          externalProductId: e.target.value,
                        })
                      );
                    }}
                  />
                </div>
              </>
            )}
          </div>
          <div className="flex justify-between items-centers mt-10">
            <button className={Classname.saveButton2} onClick={handleBack}>
              Back
            </button>
            <div className={Classname.buttonsContainer}>
              <button
                className={Classname.saveButton}
                onClick={onSave}
                disabled={loading}
              >
                {loading ? "Please Wait..." : "Save and exit"}
              </button>
              {!tourEdit && (
                <button
                  className={Classname.continueButton}
                  onClick={onContinue}
                >
                  Continue
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementPackageConnectivityPage;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  title2: "font-bold mt-6 mb-2",
  input: "flex w-full h-14 border border-gray-400 rounded-md px-4 mt-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6 ",
  description: "flex text-base mb-4 mt-2",
  buttonsContainer: "flex max-lg:justify-between gap-3 max-lg:w-full",
  addressButton:
    "font-bold w-fit flex items-center gap-2 cursor-pointer text-primary1 py-3 px-3 border rounded-lg",
  saveButton:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  saveButton2:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md max-lg:hidden",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
